import React from "react";

/**
 * Wraps content that must be masked in Amplitude session replay (user-generated / user-identifiable content).
 *
 * Renders a single DOM element with the class required by the Amplitude session-replay SDK so that
 * text inside is replaced with *** in replays. Do not remove this component without checking
 * session replay and privacy requirements—it is required for UGC masking.
 *
 * The app shell also sets `amp-mask` on `#root` in `public/index.html` so rrweb masks async-loaded
 * content before per-widget wrappers are required.
 *
 * @see initializeSessionReplay (maskSelector / blockSelector config)
 */
export const SessionReplayUGC = ({
  as: Component = "div",
  children,
}: {
  /** Render as this element. Use "span" for inline wrapping (e.g. a single phrase). Default "div". */
  as?: "div" | "span";
  children: React.ReactNode;
}): React.JSX.Element => {
  return <Component className="amp-mask">{children}</Component>;
};
